import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private _title = inject(Title);
  private _translate = inject(TranslateService);
  private _currentKey?: string;

  constructor() {
    super();
    // Re-translate the current title whenever the user switches language so the
    // browser tab stays in sync with the in-app i18n switch.
    this._translate.onLangChange.subscribe(() => {
      if (this._currentKey) this._applyKey(this._currentKey);
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (!title) return;
    this._currentKey = title;
    this._applyKey(title);
  }

  // translate.get() is async and waits for the active language bundle to load,
  // so cold-load navigations no longer flash the raw i18n key in the tab title.
  private _applyKey(key: string): void {
    this._translate.get(key).subscribe((translated) => {
      this._title.setTitle(translated !== key ? translated : key);
    });
  }
}
